import React from 'react';
import Slider from 'react-slick';
import img1 from '../../media/coristo.png';
import img2 from '../../media/b&b.png';
import img3 from '../../media/basiaCarrousel.png';
import img4 from '../../media/promyk.png';
import img5 from '../../media/ponchoCarrousel.png';
import img6 from '../../media/p&b.png';
import field from '../../media/field.jpg';
import { Grid, Box, Typography } from '@mui/material';
import { useThemeContext } from '../global/ThemeContext';
import './Carrousel.css';

const Carrousel = () => {
  const { darkMode } = useThemeContext();
  const imgs = [
    { src: img1, name: 'Coristo' },
    { src: img2, name: 'Bajka & Balou' },
    { src: img3, name: 'Barbara Jimenez' },
    { src: img4, name: 'Promyk' },
    { src: img5, name: 'Alfonso Jimenez' },
    { src: img6, name: 'Pasja & Frika' },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000, // Slower transition speed
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000, // Match previous interval
    fade: true, // Use fade effect
    cssEase: 'linear',
    pauseOnHover: true,
    appendDots: (dots: React.ReactNode) => (
      <Box sx={{ position: 'absolute' }}>
        {' '}
        {/* Remove inline bottom style */}
        <ul style={{ margin: '0px' }}> {dots} </ul>
      </Box>
    ),
    // Add custom arrows if needed, or rely on default/CSS styling
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{
        padding: '20px 0',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background Boxes remain the same */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${field})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(10px)',
          zIndex: -2,
          animation: 'growBackground 15s infinite alternate ease-in-out',
          '@keyframes growBackground': {
            '0%': {
              transform: 'scale(1)',
            },
            '100%': {
              transform: 'scale(1.1)',
              transformOrigin: 'center center',
            },
          },
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: darkMode ? 'rgba(0, 0, 0, 0.55)' : 'rgba(0, 0, 0, 0.3)',
          zIndex: -1,
        }}
      />

      {/* React Slick Slider */}
      <Grid item xs={12} md={10} sx={{ width: '100%' }}>
        <Slider {...settings}>
          {imgs.map((img, index) => (
            <div key={index}>
              <Grid container justifyContent="center" alignItems="center" sx={{ px: { xs: 2, md: 5 } }}>
                {' '}
                {/* Add padding */}
                <Grid item xs={12} md={8}>
                  <div style={{ position: 'relative', paddingTop: '45%' }}>
                    <img
                      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'scale-down' }}
                      src={img.src}
                      alt={img.name}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography
                    variant="h6"
                    color={'#FFF'}
                    textTransform={'uppercase'}
                    fontWeight={300}
                    sx={{
                      textAlign: { xs: 'center', md: 'left' },
                      borderBottom: '.1rem solid #FFF',
                      mt: { xs: 2, md: 0 }, // Add margin top on small screens
                      pb: 1, // Padding bottom for the text
                      ml: { md: 2 }, // Margin left on medium screens
                    }}
                  >
                    {img.name}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          ))}
        </Slider>
      </Grid>
    </Grid>
  );
};

export default Carrousel;
